import { createContext, useContext } from 'react';
import { ResponseTemplatePopperMetadata } from 'react-scale/components/scalers/tasks/ThreadedInteraction/ResponseTemplateCreator/ResponseTemplateCreatorStep';

export const ChatStepChildIdContext = createContext({
  childId: undefined as undefined | string,
  metadata: undefined as undefined | ResponseTemplatePopperMetadata,
});

export const useChatStepChildIdContext = () => useContext(ChatStepChildIdContext);
